import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const LIST_ORGANIZATIONS = "ORGANIZATION:LIST_ORGANIZATIONS";

export interface ListOrganizationsAction extends Action {
  type: typeof LIST_ORGANIZATIONS;
  organization: OrganizationKeyName;
}

export const listOrganizationsAction = (
  organization: OrganizationKeyName
): ListOrganizationsAction => ({
  type: LIST_ORGANIZATIONS,
  organization,
});
